export default __webpack_public_path__ + "static/media/bg_main_trade.b4156e1dde033793ad6a8614a282551c.svg";